<div [formGroup]="assetItemForm">
  <div class="thumbnail" #assetThumbnail [class.active]="isLoading"
    [matTooltip]="assetItemForm.get('name').value" matTooltipPosition="below"
    (clickOutside)="unsetClass('document')" (click)="setClass('document')">
    <div *ngIf="isLoading; else elseBlock" class="active thumbnail-upload-progress">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <ng-template #elseBlock>
      <div [ngClass]="{ 'thumbnail-action': thumbnailIsClicked }">
        <div class="controls">
          <a class="control-btn move"><i class="material-icons" (click)="stopPropagation($event); showFullSize(assetItemForm)">open_with</i></a>
          <a class="control-btn remove readonly-disabled" [ngClass]="{'disabled-anchor' : preventRemoval  }"><i class="material-icons" (click)="$event.stopPropagation(); !preventRemoval && removeItem(current)" [ngClass]="{'disabled' : preventRemoval  }">delete</i></a>
        </div>
        <i class="material-icons watermark hoverable">attach_file</i>
      </div>
    </ng-template>
  </div>
  <p class="img-title">{{ assetItemForm.get('name').value }}</p>
</div>
<!-- <modal-prompt></modal-prompt> -->